export default __webpack_public_path__ + "static/media/shop-by-price.c01b821d.png";